import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { Dropdown, Icon } from 'semantic-ui-react';

import REPORT_TYPES from '../../utils/report-types';
import ThemeSelector from '../../themes/theme-selector';

const currentTheme = ThemeSelector.theme();

// Icon on the trigger so Reports reads as an action, not just another tab label.
const reportsTrigger = <span><Icon name="line graph" />Reports</span>;

const menuStyle = { width: '320px' };
const itemStyle = { padding: '10px 16px' };
const nameStyle = { fontWeight: 600 };
const descStyle = {
  display: 'block',
  fontSize: '0.8em',
  fontWeight: 'normal',
  color: 'rgba(0, 0, 0, 0.5)',
  whiteSpace: 'normal',
  lineHeight: '1.35',
  marginTop: '2px',
};

const openReport = (report, campaignId) =>
  window.open(`${currentTheme.shareSite}/report/${campaignId}/${report.link}`, '_blank');

const isPremiumReport = type => _.isEqual(type, 'premium');

// Mirrors report-card availability: premium reports always show; integration
// reports need the matching org integration / campaign type.
const isReportAvailable = (report, organisation, isShopifyCampaign, isPrestaShopCampaign) => {
  const { isFacebookAdsEnabled, isGoogleAnalyticsEnabled } = organisation || {};
  if (isPremiumReport(report.type)) return true;
  if (_.isEqual(report.subType, 'facebook') && isFacebookAdsEnabled) return true;
  if (_.isEqual(report.subType, 'google') && isGoogleAnalyticsEnabled) return true;
  if (_.isEqual(report.subType, 'shopify') && isShopifyCampaign) return true;
  if (_.isEqual(report.subType, 'prestashop') && isPrestaShopCampaign) return true;
  return false;
};

const isReportAvailableByOrg = (report, organisation) => {
  if (!report.organisations) return true;
  return _.includes(report.organisations, _.get(organisation, 'id'));
};

const ReportsDropdown = ({ campaign, organisation }) => {
  const { id: campaignId, isShopifyCampaign, isPrestaShopCampaign } = campaign || {};

  const reports = _.filter(REPORT_TYPES, report => {
    if (!isReportAvailableByOrg(report, organisation)) return false;
    return isReportAvailable(report, organisation, isShopifyCampaign, isPrestaShopCampaign);
  });

  return (
    <Dropdown item trigger={reportsTrigger} disabled={!campaignId || _.isEmpty(reports)}>
      <Dropdown.Menu style={menuStyle}>
        { _.map(reports, report =>
          <Dropdown.Item
            key={report.link}
            style={itemStyle}
            onClick={() => openReport(report, campaignId)}
          >
            <span style={nameStyle}>
              <Icon name={report.icon} />{report.name}
            </span>
            <span style={descStyle}>
              {_.truncate(report.description, { length: 90, separator: ' ' })}
            </span>
          </Dropdown.Item>,
        )}
      </Dropdown.Menu>
    </Dropdown>
  );
};

ReportsDropdown.propTypes = {
  campaign: PropTypes.object,
  organisation: PropTypes.object,
};

ReportsDropdown.defaultProps = {
  campaign: {},
  organisation: {},
};

export default ReportsDropdown;



/** WEBPACK FOOTER **
 ** ./src/containers/large-campaign/reports-dropdown.js
 **/